import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ProductRow from "../components/ProductRow";
import TabBar from "../components/TabBar";
import Glossary from "../components/Glossary";
import { apps } from "../data/products";

export default function Apps() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") === "finance" ? "finance" : "budgeting";
  const [tab, setTab] = useState(initial);

  const onChange = (id) => {
    setTab(id);
    setParams({ tab: id });
  };

  const list = tab === "budgeting" ? apps.budgeting : apps.finance;

  return (
    <main data-testid="page-apps" style={{ padding: "140px 0 100px" }}>
      <section className="container">
        <span className="eyebrow">App selection</span>
        <h1 style={{ fontSize: "clamp(44px, 6vw, 80px)", marginTop: 22, marginBottom: 18, lineHeight: 0.98 }}>
          The best <em style={{ fontStyle: "italic", color: "var(--emerald)" }}>money apps</em> for students.
        </h1>
        <p style={{ fontSize: 18, color: "var(--t2)", maxWidth: 640 }}>
          We've tested the most popular money apps and we've found what's actually worth your time. Here's CRAM's ranking of money apps, catered specifically for students.
        </p>

        <Glossary section="apps" />

        <TabBar
          testIdPrefix="apps-tab"
          active={tab}
          onChange={onChange}
          tabs={[
            { id: "budgeting", label: "Budgeting Apps", desc: "Manual tracking & active spending control" },
            { id: "finance", label: "Finance Apps", desc: "Overall wealth, tracking & credit monitoring" },
          ]}
        />

        <div style={{ position: "relative" }}>
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={tab}
              initial={{ opacity: 0, y: 12, filter: "blur(4px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              exit={{ opacity: 0, y: -8, filter: "blur(3px)" }}
              transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
              style={{ display: "flex", flexDirection: "column", gap: 16 }}
            >
              {list.map((p, i) => (
                <ProductRow key={p.slug} product={p} index={i} sectionPath="/apps" />
              ))}
            </motion.div>
          </AnimatePresence>
        </div>
        <p style={{ marginTop: 36, textAlign: "center", fontSize: 13.5, color: "var(--t3)" }}>
          Information accurate as of August 31st, 2026.
        </p>
      </section>
    </main>
  );
}
